import { Injectable } from '@angular/core';
import { CollectionApiClient } from '../../../../core/data-access/http-client/clients/api-client-service';
import { HttpClient } from '@angular/common/http';
import { IUpdateUserRequest } from '../dtos/requests/update-account-user.request';
import { Observable } from 'rxjs';
import { IUserContext } from '../../../auth-management/authentication/models/user-context.model';
import { UserManagementCollections } from '../../../common/collections/user-management.collections';

@Injectable({
    providedIn: 'root'
})
export class CurrentUsersApiClient {
    private collectionApiClient: CollectionApiClient;

    constructor(protected http: HttpClient) {
        this.collectionApiClient = CollectionApiClient.create(UserManagementCollections.CurrentUser, http);
    }

    update(body: IUpdateUserRequest): Observable<void> {
        return this.collectionApiClient.put({ body: body });
    }

    get(): Observable<IUserContext> {
        return this.collectionApiClient.get();
    }
}
